import zhElementLocale from 'element-ui/lib/locale/lang/zh-CN'

export default Object.assign({}, zhElementLocale, {
  common: {
    project: '项目',
    placeholder: {
      plzChoose: '请选择'
    },
    tablehead: {
      action: '操作'
    },
    buttons: {
      cancel: '取消',
      save: '保存',
      submit: '提交',
      ok: '确定',
      check: '查看',
      close: '关闭',
      edit: '编辑',
      rename: '重命名',
      delete: '删除',
      contactUs: '联系我们',
      return: '返回',
      copy: '复制',
      preview: '预览',
      export: {
        default: '导出',
        html5: '导出 H5',
        scorm: '导出 SCORM'
      },
      record: '语音录制',
      finishRecord: '完成录制'
    },
    infos: {
      copy: '已保存到剪切板'
    },
    errors: {
      server: '服务器暂时故障，请刷新重试：{message}',
      uploading: '上传出现问题，请重试或尝试其他浏览器'
    },
    order: {
      labels: {
        name: '操作@:common.project',
        price: '付费金额',
        payType: '支付方式'
      },
      wechat: '微信',
      alipay: '支付宝'
    }
  },
  messagebox: {
    category: {
      delete: {
        title: '移除分组: {name}',
        message: '删除分组后，该分组的@:common.project仍然会保留，是否继续？'
      }
    },
    project: {
      delete: {
        title: '删除@:common.project: {name}',
        message: '该操作将使生成的二维码和网址无法再继续访问，是否继续？'
      },
      rename: {
        title: '@:common.project重命名',
        inputError: '@:common.project名不能为空'
      }
    },
    media: {
      audio: {
        delete: {
          title: '从素材库中移除该音乐?',
          message: '注意，该操作不会使之前引用的文件失效'
        }
      },
      image: {
        delete: {
          title: '从素材库中移除该图片?',
          message: '注意，该操作不会使之前引用的文件失效'
        }
      }
    }
  },
  actions: {
    headbar: {
      returnIndex: '回到首页',
      help: '帮助',
      vip: '会员服务',
      members: '成员管理',
      price: '价格',
      myProjects: '我的@:common.project',
      myAccount: '我的账户',
      logout: '退出登录',
      logoutMessage: '已注销',
      login: '已有账号，请登录',
      register: '立即注册'
    },
    login: {
      title: '登录账号',
      login: '登录',
      wxlogin: '微信登录',
      accountlogin: '账号登录',
      register: '立即注册',
      password: '找回密码'
    },
    findPassword: {
      title: '找回密码',
      submit: {
        email: '发送验证邮件',
        cellphone: '验证手机号'
      },
      returnLogin: '返回登录',
      placeholder: '请输入账号邮箱',
      sended: {
        title: '验证邮件已送达: {email}',
        hint: '请登录邮箱，使用验证邮件中的链接重置密码'
      }
    },
    register: {
      title: '欢迎注册',
      term: "点击“立即注册”，表明您已阅读并同意<a class='link' href='/static/service_protocol.html' target='_blank'>服务协议</a>和<a class='link' href='/static/privacy_policy.html' target='_blank'>隐私政策</a>",
      submit: '立即注册',
      loginLink: '已有账号，马上登录'
    },
    cellphoneRegister: {
      title: '手机号注册'
    },
    resetPassword: {
      title: '重置密码',
      submit: '重置密码'
    },
    wxlogin: {
      title: '微信登录'
    },
    wxbind: {
      title: '尚未绑定PP匠账号，立即绑定！',
      submit: '绑定PP匠账号'
    },
    category: {
      all: '全部@:common.project',
      edit: '修改分组',
      new: '新建分组',
      remove: '删除分组',
      publicity: '公开访问',
      cover: '点击编辑分组封面',
      noMore: '已到底部',
      noResults: '暂无@:common.project'
    },
    project: {
      new: '新建@:common.project',
      updatePPT: '更新 PPT',
      moveTo: '移动至',
      alterCover: '替换封面',
      steps: {
        upload: '上传@:common.project',
        convert: '转化 H5',
        complete: '分享链接'
      },
      stats: {
        data: '@:common.project数据',
        form: '表单统计'
      },
      settings: {
        basic: '常用设置',
        advanced: '高级设置',
        cancel: '放弃修改',
        wxshare: '微信分享',
        wxcover: '点击编辑封面',
        arrow: '翻页箭头',
        stretch: '页面适配',
        stretchValue: {
          auto: '自动',
          fullscreen: '撑满',
          restrict: '缩放',
          smart: '智能填充'
        },
        autoplayLabel: '动画控制',
        autoplay: {
          enabled: '自动播放',
          original: '还原PPT'
        },
        access: '访问限制',
        accessTypes: {
          none: '无',
          code: '密码访问',
          pay: '付费阅读',
          spell: '公众号推广'
        },
        accessLabels: {
          code: '访问密码',
          random: '随机生成',
          hint: '密码提示',
          previewPages: '预览页数',
          price: '价格（元）',
          wechat: '微信号',
          spell: '回复口令'
        },
        bgmLabel: '背景音乐',
        bgm: {
          submit: '选择上传'
        },
        logoLabel: 'LOGO 设置',
        logo: {
          default: '默认PP匠',
          custom: '自定义',
          hide: '隐藏',
          cover: '点击编辑 LOGO',
          price: '该功能为付费功能，费用为每@:common.project 99 元，',
          priceBtn: '点击购买',
          title: '购买自定义logo权限',
          price2: '￥ 99.00 元 / @:common.project'
        }
      }
    },
    export: {
      paid: {
        title: '@:common.project导出',
        submit: '点击链接下载文件'
      },
      unpaid: {
        title: '购买@:common.project导出权限',
        price: '￥ 120.00 元 / @:common.project'
      }
    },
    record: {
      title: '录制语音',
      loading: '正在获取录制链接',
      editView: '录制页面',
      clientView: '播放页面'
    },
    imageUploader: {
      defaultCoverHint: '单击上传图片'
    },
    order: {
      wechat: {
        title: '支付',
        hint: '打开微信，扫码完成支付'
      },
      loading: '下单中，请稍后',
      paid: '支付成功，即将返回上一界面...',
      questions: '遇到问题？'
    }
  },
  placeholder: {
    category: {
      name: '分组名称',
      description: '分组描述'
    },
    project: {
      name: '@:common.project名称',
      viewer_url: '网页地址',
      client_url: '播放地址',
      title: '分享标题',
      description: '分享描述',
      auth_config: {
        code: '3-20位字母或数字',
        hint: '例：公司电话号码',
        wechat: '微信公众号的微信ID',
        spell: '设置回复口令'
      }
    },
    user: {
      email: '账号邮箱',
      cellphone: '用户手机号码',
      emailOrCellphone: '邮箱或手机号',
      captcha: '验证码',
      password: '账号密码',
      oldPassword: '原始密码',
      newPassword: '新的密码',
      passwordConfirmation: '请再次输入密码'
    }
  },
  hint: {
    project: {
      convert: {
        main: '正在生成中，大概需要 1 - 3 分钟，请稍候...',
        secondary: '完成后自动跳转下一步，请勿关闭本页面'
      },
      edit: {
        access: {
          none: '请放心，PP 匠生成的链接是私密安全的请放心使用，访问限制只是进一步控制权限。',
          code: '密码访问提示文案',
          pay: '付费阅读提示文案',
          spell: '公众号推广提示文案'
        },
        bgm: '文件限制 10M, 建议将音乐裁剪至 40 秒内以保证加载速度。',
        logo: {
          default: '加载页默认用PP匠logo',
          hide: '加载页不显示logo'
        }
      },
      export: {
        main: '导出会将H5打包为zip文件下载到本地，包含生成的html、js以及图片等资源',
        secondary: '注意：购买后@:common.project只有两次导出的机会，请确认转化效果满意后再使用'
      },
      logo: {
        main: '您的@:common.project可以更新加载页的logo'
      },
      record: {
        main: '使用微信在 h5 页面中添加语音，可以用来录制微课或解说',
        secondary: '微信扫码进入录制页面',
        error: '请确保在手机编辑的最后一页点击“完成录制”按钮'
      }
    },
    media: {
      audio: {
        empty: '暂无音乐'
      },
      image: {
        empty: '暂无图片',
        uploading: '上传中',
        remove: '从素材库中移除该图片'
      }
    }
  },
  qrcode: {
    convert: '微信扫一扫<br />即时获取生成进度',
    project: '手机扫码，浏览作品'
  },
  project: {
    state: {
      uploading: '转化中',
      converting: '转化中',
      rendering: '转化中',
      disting: '转化中',
      redisting: '转化中',
      finishing: '发布中',
      completed: '已完成',
      halted: '异常',
      expired: '已过期',
      temp: '临时'
    }
  }
})



// WEBPACK FOOTER //
// ./src/i18n/locale/zh-CN/index.js